import { Box, Stack, Typography } from '@mui/material';
import type { RenderSignal } from 'shared';
import { tokens } from '../theme';

/**
 * Dải cảnh báo trang dựng bằng JavaScript — spec SC-15 §3.2.
 *
 * Đặt NGAY TRÊN ba vòng điểm, không đặt cuối trang: điều cần nói là "đừng tin
 * mấy con số ngay dưới đây", nói sau khi người ta đã đọc xong thì vô nghĩa.
 *
 * Dùng khối riêng thay vì `Note` vì nó phải nổi hơn hẳn mọi ghi chú khác trong
 * màn — đây là lời cải chính cho chính kết quả mà màn này đang trình bày.
 */

/** Nhãn khai lại ở FE: `shared` biên dịch CommonJS nên chỉ import KIỂU được. */
const NHAN: Record<RenderSignal, string> = {
  'thin-vs-bytes': 'rất ít chữ so với dung lượng HTML',
  'no-heading': 'không có thẻ tiêu đề nào',
  'empty-app-root': 'có khung ứng dụng rỗng (#root / #app)',
  'script-heavy': 'nhiều thẻ script mà rất ít nội dung',
  'noscript-notice': 'trang yêu cầu bật JavaScript',
};

export function RenderWarning({ signals }: { signals: readonly RenderSignal[] }) {
  const mo_ta = signals.map((s) => NHAN[s]).filter(Boolean);

  return (
    <Stack
      direction="row"
      spacing={1.6}
      sx={{
        bgcolor: tokens.amberBg,
        border: `1px solid ${tokens.amber}`,
        borderRadius: '10px',
        px: 2,
        py: 1.8,
        mb: 2.5,
      }}
    >
      <Box
        sx={{
          flex: 'none',
          width: 24,
          height: 24,
          borderRadius: '50%',
          bgcolor: tokens.amber,
          color: '#fff',
          display: 'grid',
          placeItems: 'center',
          fontSize: 14,
          fontWeight: 700,
          lineHeight: 1,
        }}
      >
        !
      </Box>
      <Box>
        <Typography sx={{ fontSize: 14.5, fontWeight: 600, color: '#5C4426', mb: 0.4 }}>
          Trang này có thể được dựng bằng JavaScript
        </Typography>
        <Typography sx={{ fontSize: 13.5, color: '#5C4426' }}>
          Copilot chỉ đọc HTML mà máy chủ trả về, nên có thể không thấy phần lớn nội dung —{' '}
          <strong>điểm số dưới đây không đáng tin</strong>. Các đề xuất thuộc nhóm nội dung cũng đã
          được bỏ qua thay vì đưa ra lời khuyên dựa trên dữ liệu đọc hụt.
        </Typography>
        {mo_ta.length > 0 && (
          <Typography sx={{ fontSize: 12.5, color: '#7A5C33', mt: 0.6 }}>
            Dấu hiệu nhận ra: {mo_ta.join(' · ')}.
          </Typography>
        )}
        <Typography sx={{ fontSize: 12.5, color: '#7A5C33', mt: 0.6 }}>
          Đây cũng là một vấn đề SEO thật: máy tìm kiếm cũ và trình đọc màn hình gặp đúng khó khăn
          này với trang của bạn.
        </Typography>
      </Box>
    </Stack>
  );
}
